/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import HotelManualEvent from '../../event/HotelManualEvent'
import { HouseManualState } from '../state/HouseManualState'

class HouseManualStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new HouseManualState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case HotelManualEvent.onCancelAndCloseDialog:
        return state.clear()

      case HotelManualEvent.fetchOne:
        return new HouseManualState().mergeModel(payload)

      case HotelManualEvent.created:
        return state.clear()

      case HotelManualEvent.updated:
        return state.clear()

      case HotelManualEvent.onEdit:
        return state.set(payload.name, payload.value)

      case HotelManualEvent.onClear:
        return state.merge({ manual: null, manual_name: '', manual_url: '' })

      case HotelManualEvent.onUpload:
        return state.merge({ manual_name: payload.fileName, manual: payload.fileContent })

      default:
        return state
    }
  }
}

export default new HouseManualStore()
